import { format, parseISO, differenceInDays, isBefore } from 'date-fns';

export const getDueDateInfo = (dueDate) => {
  if (!dueDate) return null;
  
  const date = parseISO(dueDate);
  const today = new Date();
  const daysLeft = differenceInDays(date, today);
  const isOverdue = isBefore(date, today);
  
  let color = 'success.main';
  if (isOverdue) {
    color = 'error.main';
  } else if (daysLeft <= 3) {
    color = 'warning.main';
  }
  
  return {
    daysLeft,
    isOverdue,
    color,
    formattedDate: format(date, 'MMM d, yyyy')
  };
}; 